import { forwardRef, useState } from 'react';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TextInput = forwardRef(
    (
        { label, name, type = 'text', autocomplete, error, disableTab, hint, rows, ...props },
        ref
    ) => {
        const [showTooltip, setShowTooltip] = useState(false);
        const errorId = `${name}-error`;

        const toggleTooltip = () => setShowTooltip(prev => !prev);
        const showOnFocus = () => setShowTooltip(true);
        const hideOnBlur = () => setShowTooltip(false);

        const sharedProps = {
            id: name,
            name,
            autoComplete: autocomplete,
            placeholder: ' ',
            'aria-invalid': !!error,
            'aria-describedby': error ? errorId : undefined,
            ref,
            ...props
        };

        return (
            <div className={`form-group ${error ? 'has-error' : ''}`}>
                <div className="field">
                    {type === 'textarea' ? (
                        <textarea
                            {...sharedProps}
                            rows={rows || 4}
                            tabIndex={disableTab ? -1 : 0}
                            onFocus={showOnFocus}
                            onBlur={hideOnBlur}
                        />
                    ) : (
                        <input
                            type={type}
                            tabIndex={disableTab ? -1 : 0}
                            {...sharedProps}
                            onFocus={showOnFocus}
                            onBlur={hideOnBlur}
                        />
                    )}
                    <label htmlFor={name}>{label}</label>
                    {error && (
                        <>
                            <FontAwesomeIcon
                                icon={faCircleExclamation}
                                className="error-icon"
                                size="md"
                                onClick={toggleTooltip}
                                aria-controls={errorId}
                                aria-expanded={showTooltip}
                            />

                            {showTooltip && (
                                <div id={errorId} className="field-error-tooltip" role="alert">
                                    {error.message}
                                    <span className="field-error-tooltip__arrow" />
                                </div>
                            )}
                        </>
                    )}
                </div>
                {hint && <span className="field-hint">{hint}</span>}
            </div>
        );
    }
);

TextInput.displayName = 'TextInput';
export default TextInput;
